import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LanguageToggle } from './LanguageToggle'

export function LandingFooter() {
  const { t } = useTranslation()

  return (
    <footer className="border-t border-border bg-background/60">
      <div className="mx-auto grid w-full max-w-7xl gap-8 px-4 py-10 sm:px-6 lg:grid-cols-3 lg:px-8">
        <div>
          <div className="text-sm font-medium text-foreground">Omni Sight</div>
          <p className="mt-2 max-w-xs text-[13px] leading-relaxed text-muted-foreground">
            {t('landing.footer.tagline')}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-6 text-[13px] sm:grid-cols-3">
          <div>
            <div className="mb-3 text-xs font-medium uppercase tracking-wider text-muted-foreground">
              {t('landing.footer.product')}
            </div>
            <Link
              to="/features"
              className="block text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              {t('landing.header.nav.features')}
            </Link>
            <Link
              to="/platform"
              className="mt-2 block text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              {t('landing.footer.platform')}
            </Link>
          </div>

          <div>
            <div className="mb-3 text-xs font-medium uppercase tracking-wider text-muted-foreground">
              {t('landing.footer.company')}
            </div>
            <Link
              to="/use-cases"
              className="block text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              {t('landing.header.nav.useCases')}
            </Link>
            <Link
              to="/pricing"
              className="mt-2 block text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              {t('landing.header.nav.pricing')}
            </Link>
          </div>

          <div>
            <div className="mb-3 text-xs font-medium uppercase tracking-wider text-muted-foreground">
              {t('landing.footer.contact')}
            </div>
            <a
              href="mailto:info@omnisight.mn"
              className="block text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              info@omnisight.mn
            </a>
            <Link
              to="/login"
              className="mt-2 block text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              {t('landing.footer.login')}
            </Link>
          </div>
        </div>

        <div className="flex items-start justify-start lg:justify-end">
          <LanguageToggle />
        </div>
      </div>

      <div className="border-t border-border px-4 py-4 text-center text-xs text-muted-foreground sm:px-6 lg:px-8">
        {t('landing.footer.copyright')}
      </div>
    </footer>
  )
}
